module.exports = __webpack_public_path__ + "img/jl-servce-icon_1.76f80a98.png";